import * as React from 'react';

export type TButtonProps = {
	name: string;
	text: string;
	className?: string;
	onClick?: (event: any) => void;
	disabled?: boolean;
};

const Button: React.StatelessComponent<TButtonProps> = ({ name, text, className, onClick, disabled }) => {
	let classes = className ? className : '';
	className
		? (classes +=
				' font-roboto text-lg w-full inline-flex justify-center focus:outline-none focus:shadow-none px-8 py-2.5 sm:ml-3 sm:w-auto')
		: (classes = 'w-full inline-flex justify-center focus:outline-none focus:shadow-none');

	if (disabled === true) {
		classes += ' disabled:opacity-50';
	}
	return (
		<button className={classes} name={name} onClick={onClick} disabled={disabled}>
			{text}
		</button>
	);
};

export default Button;
